import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

class OneTimeChoice extends React.Component {
  constructor(props) {
    super(props);
    this.selectItem = this.selectItem.bind(this);
  }

  selectItem(itemId) {
    this.props.openCheckout(itemId);
  }

  lexicoinBalance() {
    const { current_user } = this.props;
    if (!current_user || current_user.lexicoins == null) {
      return 0;
    }
    return current_user.lexicoins;
  }

  render() {
    if (this.props.tab === 3) {
      return null;
    }

    const { images } = this.props;
    const balance = this.lexicoinBalance();

    return (
      <div>
        <div className="pricing-balance">
          <div className="pricing-balance__coin-wrap">
            {images.lexicoin && (
              <img src={images.lexicoin} alt="" />
            )}
          </div>
          <div>
            <p className="pricing-balance__amount">{balance}</p>
            <p className="pricing-balance__label">Lexicoins Current Balance</p>
          </div>
        </div>

        <h3 className="pricing-section-title pricing-section-title--decorated">
          <Icon name="star" solid size={18} color={primitives.blue['500']} aria-hidden="true" />
          Choose a package
          <Icon name="star" solid size={18} color={primitives.blue['500']} aria-hidden="true" />
        </h3>
        <div className="pricing-packages">
          <button
            type="button"
            className="pricing-package"
            onClick={() => this.selectItem(2)}
            aria-label="Buy 1 Lexicoin for $0.99"
          >
            <div className="pricing-package__top">
              {images.oneLexicoin && (
                <img
                  src={images.oneLexicoin}
                  alt=""
                  className="pricing-package__image"
                />
              )}
            </div>
            <div className="pricing-package__footer">
              <p className="pricing-package__price">$0.99</p>
              <span className="pricing-package__btn pricing-package__btn--outline" aria-hidden="true">
                Buy 1 Coin
              </span>
            </div>
          </button>

          <button
            type="button"
            className="pricing-package pricing-package--popular"
            onClick={() => this.selectItem(3)}
            aria-label="Buy 10 Lexicoins for $7.99"
          >
            <span className="pricing-package__badge">Most Popular</span>
            <div className="pricing-package__top">
              {images.tenLexicoins && (
                <img
                  src={images.tenLexicoins}
                  alt=""
                  className="pricing-package__image"
                />
              )}
            </div>
            <div className="pricing-package__footer">
              <span className="pricing-package__save">Save 20%</span>
              <p className="pricing-package__price">$7.99</p>
              <span className="pricing-package__btn pricing-package__btn--filled" aria-hidden="true">
                Buy 10 Coins
              </span>
            </div>
          </button>
        </div>

        <div className="pricing-secure">
          <Icon name="shield" size={22} color={primitives.blue['500']} />
          <p className="pricing-secure__text">
            Secure payments. Your purchases help keep Lexody growing! 💙
          </p>
        </div>
      </div>
    );
  }
}

OneTimeChoice.propTypes = {
  tab: PropTypes.number,
  current_user: PropTypes.object,
  openCheckout: PropTypes.func.isRequired,
  images: PropTypes.object,
};

export default OneTimeChoice;
